module.exports = __webpack_public_path__ + "img/1.ad78af40.png";